export default __webpack_public_path__ + "static/media/Ahilya-Bai-Fort-and-Palace.7c526b68.jpg";